import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=2458ca72&scoped=true&"
import script from "./ChatBubble.vue?vue&type=script&lang=js&"
export * from "./ChatBubble.vue?vue&type=script&lang=js&"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=2458ca72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458ca72",
  null
  
)

export default component.exports